import { render, staticRenderFns } from "./DataLakeDownloads.vue?vue&type=template&id=3477a834&scoped=true"
import script from "./DataLakeDownloads.vue?vue&type=script&lang=js"
export * from "./DataLakeDownloads.vue?vue&type=script&lang=js"
import style0 from "./DataLakeDownloads.vue?vue&type=style&index=0&id=3477a834&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3477a834",
  null
  
)

export default component.exports